export const BUILD_VERSION = '1791805592';
